import React, { useState, useEffect, } from 'react';
import { Button, Select, Table, Space, Modal, Form, Input, Tabs, DatePicker } from 'antd'
import { MdAddCircle } from 'react-icons/md';
import { FaPencilAlt  } from 'react-icons/fa';
import { GrClose } from 'react-icons/gr';
import * as yup from 'yup';
import moment from 'moment';
import _ from 'lodash'
import consts from '../../consts';
import utils from '../../common/utils'
import TitleContent from './TitleContent'
import { ExclamationCircleOutlined } from '@ant-design/icons';
import DisplayControl from '../DisplayControl';

const { Option } = Select;
const { RangePicker } = DatePicker;
const { confirm } = Modal;

const layout = {
   labelCol: {
      span: 4,
   },
   wrapperCol: {
      span: 20,
   },
};
const tailLayout = {
   wrapperCol: {
      offset: 8,
      span: 16,
   },
};

function range(start, end) {
   const result = [];
   for (let i = start; i < end; i++) {
      result.push(i);
   }
   return result;
}

function disabledDate(current) {
   // Can not select days before today and today
   return current && current < moment().endOf('day');
}

function disabledRangeTime(_, type) {
   if (type === 'start') {
      return {
         disabledHours: () => range(0, 60).splice(24, 20),
         disabledMinutes: () => range(60, 60),
         disabledSeconds: () => [60, 60],
      };
   }
   return {
      disabledHours: () => range(0, 60).splice(24, 4),
      disabledMinutes: () => range(60, 31),
      disabledSeconds: () => [60, 40],
   };
}

const schema = yup.object().shape({
   link: yup.string()
      .required()
      .min(1),
   date: yup.array().of(
      yup.date().required().default(function () {
         return new Date();
      }),
   ),
   map_title: yup.object({
      vi: yup.string().required().min(1).max(100),
      en: yup.string().required().min(1).max(100),
   }),
   map_content: yup.object({
      vi: yup.string().required().min(1),
      en: yup.string().required().min(1),
   })
});

const validateMessages = {
   required: 'Nhập ${label}!',
   types: {
       url: 'Liên kết không hợp lệ !',
   },
};

function Notification(props) {
   const [changeMarket, setChangeMarket] = useState('')
   const [form] = Form.useForm();
   const [visible, setVisible] = useState(false);
   const [isAddNew, setIsAddNew] = useState(false)
   const [confirmLoading, setConfirmLoading] = useState(false)
   const [currentPage, setCurrentPage] = useState(1);
   const [loading, setLoading] = useState(false);
   const [totalCount, setTotalCount] = useState(0)
   const [formEdit, setFormEdit] = useState({})
   const [isAddLanguage, setIsAddLanguege] = useState(true)
   const [id, setId] = useState('')
   const [checkLanguage, setCheckLanguage] = useState(true)
   const [panes, setPanes] = useState([
      {
         title: 'vi',
         key: '0',
         closable: false,
      },
      {
         title: 'en',
         key: '1',
         closable: false,
      },
   ])
   const [activeKey, setActiveKey] = useState(panes[0].key)
   const [addLanguage, setAddLanguage] = useState('')
   const [focus, setFocus] = useState(false)
   const [newTabIndex, setNewTabIndex] = useState(2)
   let filter = {
      pos: 0,
      count: consts.DEFAULT_PAGE_SIZE,
      market: ''
   };


   const columns = [
      {
         align: 'center',
         title: 'Thị trường',
         dataIndex: 'market',
         key: 'market',
         width: 120,
      },
      {
         title: 'Tiêu đề',
         dataIndex: 'map_title',
         key: 'map_title',
         width: 250,
         render: (title) => window._.map(title, (item, index) => (
            <div className="d-flex" key={index}>
               <div className="mr-2 ">{`${index}: `}</div>
               <div className="text-left line-clamp" style={{maxWidth: 250}} title={item}>{item}</div>
            </div>
         )),
      },
      {
         title: 'Nội dung',
         dataIndex: 'map_content_web',
         key: 'map_content_web',
         width: 400,
         render: (contentWeb) => window._.map(contentWeb, (item, index) => (
            <div className="d-flex" key={index}>
               <div className="mr-2 " title={index}>{`${index}: `}</div>
               <div className="text-left line-clamp" title={item}
               dangerouslySetInnerHTML={{__html: item}}
               ></div>
            </div>
         )),
      },
      {
         align: 'center',
         width: 190,
         title: 'Thời gian bắt đầu',
         dataIndex: 'time_start',
         key: 'time_start',
         render: (start) => utils.formatTimeFromUnix(start, 'DD/MM/YYYY HH:mm:ss')
      },
      {
         align: 'center',
         width: 190,
         title: 'Thời gian kết thúc',
         dataIndex: 'time_end',
         key: 'time_end',
         render: (end) => utils.formatTimeFromUnix(end, 'DD/MM/YYYY HH:mm:ss')
      },
      {
         align: 'center',
         width: 200,
         title: 'Liên kết',
         dataIndex: 'link',
         key: 'link',
         render: (link) => <div className="line-clamp" title={link}  style={{maxWidth: 250}}>{link}</div>
      },
      {
         width: 100,
         align: 'center',
         title: 'Hành động',
         dataIndex: 'action',
         key: 'action',
         render: (value, item) => (
            <div style={{maxWidth: 100}}>
               <Space size="middle">
               <DisplayControl permission_link_screen={consts.AUTH.ADMINNOTIFICATION} action={consts.CONTROLS.PUT}>
                  <FaPencilAlt className="styled-icon" onClick={() => showDetail(item)} />
               </DisplayControl>
               <DisplayControl permission_link_screen={consts.AUTH.ADMINNOTIFICATION} action={consts.CONTROLS.DELETE}>
                  <GrClose className="styled-icon" onClick={() => onDelete(item)} />
               </DisplayControl>
            </Space>
            </div>
         )
      },
   ];

   const showAddNotification = () => {
      setVisible(true)
      setIsAddNew(true)
   }

   const showDetail = (value) => {
      let editValue = {}
      setVisible(true)
      setIsAddNew(false)
      setId(value.id)
      editValue.title = value.map_title;
      editValue.content = value.map_content;
      editValue.contentWeb = value.map_content_web;

      form.setFieldsValue({
         market: `${value.market}`,
         link: `${value.link}`,
         titleContent: editValue,
         date: [moment(value.time_start), moment(value.time_end)]
      })
      let newPanes = []
      let i = Object.keys(value.map_title).length
      _.map(value.map_title, (item, key) => {
         return newPanes.push({
            title: key,
            key: `${i--}`,
            closable:  (key === 'vi' || key === 'en') ? false : true, 
         })
      })
      setPanes(_.reverse(newPanes))
      setNewTabIndex(newPanes.length)
   }
   
   // useEffect(() => {
   //    fetchData()
   // }, [])

   const onDelete = (item) => {
      confirm({
         title: 'Xóa thông báo này?',
         icon: <ExclamationCircleOutlined />,
         okText: 'Xác nhận',
         okType: 'danger',
         cancelText: 'Hủy',
         closable: true,
         onOk() {
           props.deleteNotifications(item.id, fetchData)
           setLoading(true)
         },
         onCancel() {},
       });
   }

   const handleCancel = () => {
      setVisible(false)
      setConfirmLoading(false)
      setCheckLanguage(true)
      setAddLanguage('')
      setPanes([
         {
           title: 'vi',
           key: '0',
           closable: false,
         },
         {
           title: 'en',
           key: '1',
           closable: false,
         },
       ]);
      form.resetFields()
   }

   const onFocus = (e) => {
      setFocus(e)
   }

   const showOptions = () => {
      return _.map(props.coin || [], (item, index) => {
         return <Option key={index} value={item.pair}>{item.pair}</Option>
      })
   }

   const fetchData = (pos = 0, count = consts.DEFAULT_PAGE_SIZE, market = changeMarket) => {
      setLoading(true)
      filter = {
         ...filter,
         pos,
         count,
         market,
      }
      setVisible(false)
      setCurrentPage(1)
      form.resetFields()
      props.fetchNotifications(filter, updateTotalCount)
   }

   const updateTotalCount = (totalCount) => {
      setTotalCount(totalCount)
      setLoading(false)
   }


   const checkTitle = (_, value) => {
      if (window._.get(value.title, 'vi')
         && window._.get(value.title, 'en')
         && window._.get(value.content, 'vi')
         && window._.get(value.content, 'en')
         && window._.get(value.contentWeb, 'vi')
         && window._.get(value.contentWeb, 'en')
      ) {

         return Promise.resolve();
      }
      // window.document.getElementsByClassName('ck-editor__editable_inline')[0].style.borderColor="red"
      return (Promise.reject('Nhập nội dung'));
   };

   const onChangeTabs = activeKey => {
      setActiveKey({ activeKey });
   };

   const onEdit = (targetKey, action) => {
      if(action === 'remove'){
         remove(targetKey)
      }
   };

   const addLanguageTitle = (e) => {
      let arr = []
      arr = _.filter(panes, (item, index) => {
         return item.title === e.target.value
      })
      if(arr.length <= 0){
         setAddLanguage(e.target.value)
         setCheckLanguage(true)
         setIsAddLanguege(false)
      }
      else{
         setCheckLanguage(false)
         setIsAddLanguege(true)
      }
   }


   const add = (e) => {
      setNewTabIndex(newTabIndex + 1);
      let activeKey =  `${newTabIndex + 1}`;
      panes.push({ title: addLanguage, key: activeKey });
      setPanes(panes)
      setActiveKey(activeKey)
      setAddLanguage('')
   };

   const remove = targetKey => {
      let activeKey;
      let lastIndex;
      panes.forEach((pane, i) => {
         if (pane.key === targetKey) {
            lastIndex = i - 1;
         }
      });
      const newPanes = panes.filter(pane => pane.key !== targetKey);
      if (panes.length && activeKey === targetKey) {
         if (lastIndex >= 0) {
            activeKey = panes[lastIndex].key;
         } else {
            activeKey = panes[0].key;
         }
      }
      setPanes(newPanes)
      setActiveKey(activeKey)
   };

   const handleOk = () => {
      form
         .validateFields()
         .then((values) => {
            setConfirmLoading(true);
            onCreate(values);
         })
         .catch((info) => {
            console.log('Validate Failed:', info);
         });
   }

   const onCreate = _.debounce(async (values) => {
      let newArrTitle = {}
      let newArrContent = {}
      let newArrContentWeb = {}
      let i = 0, j = 0,k = 0
      _.map(values.titleContent.title, (value, key) => {
         if(key === panes[i++]?.title){
            newArrTitle = {...newArrTitle, [key] : value}
      }})
      _.map(values.titleContent.content, (value, key) => {
         if(key === panes[j++]?.title){
            newArrContent = {...newArrContent, [key] : value}
      }})
      _.map(values.titleContent.contentWeb, (value, key) => {
         if(key === panes[k++]?.title){
            newArrContentWeb = {...newArrContentWeb, [key] : value}
      }})
      values.id = id;
      values.map_title = newArrTitle
      values.map_content = newArrContent
      values.map_content_web = newArrContentWeb
      values.time_start = Date.parse(values.date[0]);
      values.time_end = Date.parse(values.date[1]);
      console.log('Received values of form: ', values);
      const isValid = await schema.isValid(values)
         if (isValid) {
            isAddNew ?  props.addNotifications(values, () => {
               setConfirmLoading(false);
               fetchData()
            } ) : props.updateNotifications(values, () => {
               setConfirmLoading(false);
               fetchData()
            })
      }
  }, consts.TIME_OF_DEBOUNCE)

  const handleMarket = (value) => {
      setChangeMarket(value)
  }

  useEffect(() => {
      fetchData()
  }, [changeMarket])

  let initialValues = {
      link: '',
      titleContent: {
         title: {
            vi: '',
            en: '',
         },
         content: {
            vi: '',
            en: '',
         },
         contentWeb: {
            vi: '',
            en: '',
         }
      }
  }

   return (
      <div className="m-medium">
         <div><h2>Thông báo</h2></div>
         <div className='d-flex space-between'>
            <div >
               <Select style={{ width: 130 }} defaultValue='' onChange={handleMarket}>
                  <Option value=''>Tất cả</Option>
                  {showOptions()}
               </Select>
            </div>
            <div>
               <DisplayControl permission_link_screen={consts.AUTH.ADMINNOTIFICATION} action={consts.CONTROLS.POST}>
                  <Button onClick={showAddNotification}>
                     <Space size="small">
                        <MdAddCircle size="20" className="styled-icon" />
                        <span>Thêm thông báo</span>
                     </Space>
                  </Button>
               </DisplayControl>
               
               <Modal
                  width='50%'
                  title={'Thông báo'}
                  okText={'Xác nhận'}
                  okType={'primary'}
                  cancelText={'Hủy'}
                  style={{ top: 30 }}
                  onCancel={handleCancel}
                  onOk={handleOk}
                  confirmLoading={confirmLoading}
                  visible={visible}
               >

                  <Form {...layout}
                     initialValues={initialValues}
                     validateMessages={validateMessages}
                     onFinishFailed={props.onFinishFailed}
                     form={form} name="control-hooks"
                  >
                     <Form.Item name="market" label="Loại"
                     >
                        <Select
                           style={{
                              width: 130,
                              marginRight: 14,
                           }}
                           defaultValue={props.coin[0]?.pair}
                        >
                           {showOptions()}
                        </Select>
                     </Form.Item>
                     <Form.Item name='date' label='Thời gian'
                        rules={[
                           {
                              type: 'array',
                              required: true,
                              message: 'Nhập thời gian',
                           },
                        ]}
                     >
                        <RangePicker
                           disabledDate={disabledDate}
                           // disabledTime={disabledRangeTime}
                           showTime={{
                              hideDisabledOptions: true,
                              defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('11:59:59', 'HH:mm:ss')],
                           }}
                           placeholder={[
                              'Ngày bắt đầu', 'Ngày kết thúc'
                           ]}
                           format="DD-MM-YYYY HH:mm:ss"
                        />
                     </Form.Item>
                     <Form.Item 
                              label="Thêm ngôn ngữ"
                              validateStatus={!checkLanguage ? 'error' : null}
                              help={!checkLanguage ? 'Ngôn ngữ bị trùng' : null}
                              >
                        <div className="d-flex mb-small">
                           <Input type="text" value={addLanguage} onChange={addLanguageTitle} />
                           <Button type="primary" disabled={isAddLanguage} onClick={add} className="mr-small">Thêm</Button>
                        </div>
                     </Form.Item>
                     <Form.Item name="titleContent" label="Ngôn ngữ"
                        className="mb-medium"
                        rules={[
                           {
                              validator: checkTitle,
                              required: true
                           },
                        ]}
                       
                     >
                        <TitleContent onFocus={onFocus} onEdit={onEdit} onChangeTabs={onChangeTabs} panes={panes} />
                     </Form.Item>
                     <Form.Item
                        name='link'
                        label='Liên kết'
                        rules={[
                           {
                              required: true,
                              type: 'url',
                           }
                        ]}
                     >
                        <Input />
                     </Form.Item>
                  </Form>
               </Modal>
            </div>
         </div>
         <div className="mt-medium">
            <Table columns={columns} dataSource={props.notification || []}
               pagination={{
                  current: currentPage,
                  onChange: (page, pageSize) => {
                     fetchData((page - 1) * pageSize, pageSize, changeMarket)
                     setCurrentPage(page)
                  },
                  defaultPageSize: consts.DEFAULT_PAGE_SIZE,
                  total: totalCount || 0,
                  hideOnSinglePage: true,
               }}
               bordered
               loading={loading}
            />
         </div>
      </div>
   )
}

export default Notification;